import { render } from "./ManageForms.vue?vue&type=template&id=45c5d966&scoped=true&ts=true"
import script from "./ManageForms.vue?vue&type=script&lang=ts"
export * from "./ManageForms.vue?vue&type=script&lang=ts"

import "./ManageForms.vue?vue&type=style&index=0&id=45c5d966&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c5d966"]])

export default __exports__